import { Component, OnInit } from '@angular/core';
import { Constant } from '../constant';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.css'],
    providers: [Title],
    standalone: false
})
export class PrivacyComponent implements OnInit {
  public readonly Constant = Constant;
  constructor(private title: Title) {
    this.title.setTitle(Constant.pageTitlePrivacy + Constant.pageTitleCommon);
  }

  ngOnInit() {}
}
